import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SettlementOverview} from '../../../../domain/settlement-overview';
import {InsightsPeriod} from '../../../../domain/insights-period';
import {SettlementOverviewFilter} from '../../../../domain/filter/settlement-overview-filter';
import {IonicModule} from '@ionic/angular';
import {DatePipe} from '@angular/common';
import {SettlementOverviewDetailsListItemComponent} from '../settlement-overview-details-list-item/settlement-overview-details-list-item.component';
import {DecimalAmountPipe} from '../../../../pipes/decimal-input/decimal-input.pipe';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-settlement-overview-details-list',
  imports: [
    IonicModule,
    SettlementOverviewDetailsListItemComponent,
    DatePipe,
    DecimalAmountPipe,
    TranslateModule
  ],
  templateUrl: './settlement-overview-details-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./settlement-overview-details-list.component.scss']
})
export class SettlementOverviewDetailsListComponent implements OnChanges {
  @Input() activeTenor: InsightsPeriod;
  @Input() settlementOverview: SettlementOverview;
  @Input() symbol: string;
  @Input() settlementOverviewFilter: SettlementOverviewFilter;

  total: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.settlementOverview.currentValue !== changes.settlementOverview.previousValue) {
      this.total = this.settlementOverview.currencyOverviews
        .find(currencyOverview => currencyOverview.currency === this.symbol).totalNetAmount;
    }
  }
}
